<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h5">
        Notifications
      </h3>
      <b-dropdown
        right
        variant="link"
        no-caret
      >
        <template #button-content>
          <i class="fa fa-ellipsis-h text-body"></i>
        </template>
        <b-dropdown-item
          @click.prevent="confirmMarkAllAsRead()"
        >
          <i class="fa fa-fw fa-check mr-1"></i>
          Mark all as read
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <notification
      v-for="n in notifications"
      :key="`notification_${n.id}`"
      :notification="n"
    ></notification>
    <div
      v-if="loaded && notifications.length < 1"
    >
      <small>You have no notifications.</small>
    </div>
  </div>
</template>

<script>
import Notification from './Notification'
import NotificationTitle from './NotificationTitle'
import NotificationContent from './NotificationContent'
import { get } from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import alertify from 'alertify.js'

export default {
  components: {
    Notification
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    ...mapGetters('notifications', {
      notifications: 'getNotifications'
    })
  },
  mounted () {
    this.loadNotifications()

    window.Echo.private('App.User.' + get(window, 'Redwood.identity.userId'))
      .notification((notification) => {
        this.addNotification(notification)

        this.$bvToast.toast([
          this.$createElement(NotificationContent, {
            props: {
              notification
            }
          })
        ], {
          title: [
            this.$createElement(NotificationTitle, {
              props: {
                notification
              }
            })
          ],
          solid: true,
          autoHideDelay: 5000
        })
      })
  },
  methods: {
    ...mapActions('notifications', [
      'loadNotifications',
      'markAllAsRead',
    ]),
    ...mapMutations('notifications', [
      'addNotification'
    ]),
    confirmMarkAllAsRead () {
      alertify.confirm('Are you sure you want to mark all of your notifications as read?', () => {
        this.markAllAsRead()
      })
    }
  }
}
</script>